import { useTranslation } from 'react-i18next';
import { useCompany } from '../context/CompanyContext';
import { useEffect } from 'react';

const USER_LANGUAGE_KEY = 'user-selected-language';

export const useI18n = () => {
  const { i18n } = useTranslation();
  const { selectedCompany } = useCompany();

  // Initialize language on first load - Company language takes priority
  useEffect(() => {
    if (selectedCompany.selectedCompany?.lang) {
      // Company language has priority
      const companyLang = selectedCompany.selectedCompany.lang;
      if (i18n.language !== companyLang) {
        i18n.changeLanguage(companyLang);
      }
    } else {
      // No company selected, check for user's manual selection
      const userSelectedLang = localStorage.getItem(USER_LANGUAGE_KEY);
      if (userSelectedLang && i18n.language !== userSelectedLang) {
        i18n.changeLanguage(userSelectedLang);
      }
    }
  }, [selectedCompany.selectedCompany?.lang, i18n]);

  // Function to change language and update company preference
  const changeLanguage = async (language: string) => {
    await i18n.changeLanguage(language);
    
    // If a company is selected, update its language preference
    if (selectedCompany.selectedCompany) {
      // Update the company's language preference
      selectedCompany.selectedCompany.lang = language;
      // This would typically call an API to update the company's language in the database
      console.log(`Language changed to ${language} for company ${selectedCompany.selectedCompany.id}`);
    } else {
      // No company selected, save user's language preference to localStorage
      localStorage.setItem(USER_LANGUAGE_KEY, language);
    }
  };

  // Function to clear user's language preference
  const clearUserLanguagePreference = () => {
    localStorage.removeItem(USER_LANGUAGE_KEY);
  };

  return {
    ...useTranslation(),
    changeLanguage,
    clearUserLanguagePreference,
    currentLanguage: i18n.language,
    isRTL: i18n.language === 'ar'
  };
};
